module.exports = __webpack_public_path__ + "static/media/img_homepage_menu_03-Featured_active.844fe0ef.png";